<template lang="pug">
  #LabelIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 顧客喜好列表
    .container-width
      .p-3
        .mb-3
          h5.mb-3(
            style="color: #6c757d;"
          ) 品牌建立
          b-card.border-0.mb-2.customerCard.word-break-all(
            no-body
            bg-variant="white",
            v-for="(tag,index) in backendTags",
            :key="tag.id",
            @click="editHandler(tag, 'backend')"
          )
            .row.p-2
              .col-10.d-flex.align-items-center
                span.mr-3.font-weight-bold {{ tag.tag_name }}
                i.fas.fa-user.mr-1.text-danger
                span.text-danger {{ tag.use_count }}
          p.mb-0(
            v-if="tags.length === 0"
          ) 無品牌建立資料

        .mb-3
          h5.mb-3(
            style="color: #6c757d;"
          ) 美容顧問建立
          b-card.border-0.mb-2.customerCard.word-break-all(
            no-body
            bg-variant="white",
            v-for="(tag,index) in tags",
            :key="tag.id",
            @click="editHandler(tag, 'ba')"
            v-if="backendTags"
          )
            .row.p-2
              .col-10.d-flex.align-items-center
                span.mr-3.font-weight-bold {{ tag.tag_name }}
                i.fas.fa-user.mr-1.text-danger
                span.text-danger {{ tag.use_count }}
          p.mb-0(
            v-if="backendTags.length === 0"
          ) 無美容顧問建立資料
        //.text-center
          b-button(
            variant="remind",
            class="mb-3 font-weight-bold",
            v-if="nowSelect === 'ba'",
            @click="$router.push({ name: 'sic-label-create' })",
            style="border: 0.3rem solid #000;border-radius: 9487px;padding: 5px 20px;box-shadow: 0.2rem 0.2rem 0 #00000033;"
          ) ＋新增喜好
</template>

<script>
import { mapState } from 'vuex';
import defaultPhotoStickerUrl from '@/assets/images/default/defaultImg404.png';
import { SIC_LABEL_EDIT, SIC_LABEL_SHOW } from '@/router/sic/label';

export default {
  name: 'LabelIndex',
  data() {
    return {
      defaultPhotoSticker: `this.src="${defaultPhotoStickerUrl}"`,
      nowSelect: 'ba',
      toolsOpen: [],
      store: null
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.getTagsHandler();
  },
  methods: {
    // 取得前台標籤
    getTagsHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '喜好列表載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得標籤
      vm.$store.dispatch('sic_label/getTagsHandler')
        .then(() => {
          // 取得標籤
          vm.$store.dispatch('sic_label/getBackendTagsHandler')
            .then(() => {
              vm.$swal.close();
            });
        });
    },
    toolsHandler(index) {
      const vm = this;
      if (vm.toolsOpen.indexOf(index) === -1) {
        vm.toolsOpen.push(index);
      } else {
        vm.toolsOpen.splice(vm.toolsOpen.indexOf(index), 1);
      }
    },
    pushHandler(tag) {
      const vm = this;
      if (!tag.use_count || tag.use_count === 0) return;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      let apiTarget;

      switch (vm.nowSelect) {
        case 'ba':
          apiTarget = 'showTagHandler';
          break;
        case 'backend':
          apiTarget = 'showBackendTagHandler';
          break;
        default:
          break;
      }

      if (!vm.nowSelect || !apiTarget) {
        vm.$swal.fire({
          icon: 'error',
          title: '推播目標錯誤[Err: Not Has NowSelect]'
        });
        return;
      }

      vm.$store.dispatch(`sic_label/${apiTarget}`, {
        tag_id: tag.tag_id
      })
        .then((res) => {
          vm.$swal.close();
          vm.$store.commit('sic_label/setMemberShowList', res.has_tag_members);
          vm.$router.push({
            name: SIC_LABEL_SHOW
          });
        });
    },
    editHandler(tag, mode) {
      const vm = this;
      vm.$router.push({
        name: SIC_LABEL_EDIT,
        params: {
          tag_id: tag.tag_id,
          mode
        }
      });
    },
    deleteHandler(tag) {
      const vm = this;
      vm.$swal.fire({
        title: '您確定刪除顧客喜好?',
        text: '刪除後無法復原！',
        html: `請注意，刪除後顧客將失去<span style="color: #d33"> ${tag.tag_name} </span> 顧客喜好`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'custom-swal-btn',
          cancelButton: 'custom-swal-btn'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '標籤刪除中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          vm.$store.dispatch('sic_label/destroyTagHandler', {
            tag_id: tag.tag_id
          })
            .then(() => {
              vm.$swal.close();
              vm.$store.commit('sic_label/resetAll');
              vm.getTagsHandler();
            });
        }
      });
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'ba':
          if (vm.nowSelect === 'ba') return;
          vm.nowSelect = 'ba';
          vm.$store.commit('sic_label/resetAll');
          vm.getTagsHandler();
          break;
        case 'backend':
          if (vm.nowSelect === 'backend') return;
          vm.nowSelect = 'backend';
          vm.$store.commit('sic_label/resetAll');
          vm.getBackendTagsHandler();
          break;
        default:
          break;
      }
    }
  },
  computed: {
    ...mapState({
      tags: (state) => state.sic_label.tags,
      backendTags: (state) => state.sic_label.backendTags,
      personnelStore: (state) => state.sic_stores_manager.personnelStoreData
    })
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: 0.2rem solid #000!important;
  border-radius: 0.8rem;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
  &-hasNews {
    &::after {
      content: "";
      position: absolute;
      right: 0.4rem;
      top: 0.4rem;
      background-color: #ef4852;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
    }
  }
}

@font-face {
 font-family: "icon";
 src: url("../../../assets/fonts/icon.eot?hrpp7d");
 src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
 font-weight: normal;
 font-style: normal;
 font-display: block;
}

i.custom {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-icon_megaphone:before {
 content: "\e912";
}

.iconDelete:before {
 content: "\e908";
}
</style>
